
import Vue from 'vue'
import { createProvider } from '@/vue-apollo'

import fetchFacultyListQuery from '@/graphql/queries/fetchFacultyList.gql'
import fetchFacultyQuery from '@/graphql/queries/fetchFaculty.gql'
import facultyCreateMutation from '@/graphql/mutations/facultyCreate.gql'
import facultyPatchMutation from '@/graphql/mutations/facultyPatch.gql'
import facultyDeleteMutation from '@/graphql/mutations/facultyDelete.gql'
import facultySetStaffMutation from '@/graphql/mutations/setFacultyStaff.gql'
import facultySetDeanMutation from '@/graphql/mutations/setFacultyDean.gql'

const apolloClient = createProvider().defaultClient
const loadingStateKey = 'faculties'

const state = {
  all: []
}

const actions = {
  fetchFacultyList: async ({ commit }) => {
    commit('setLoadingState', { key: loadingStateKey, isLoading: true }, { root: true })
    const result = await apolloClient.query({ query: fetchFacultyListQuery, fetchPolicy: 'no-cache' })
    commit('setAllFacultyList', result.data.faculties)
    commit('setLoadingState', { key: loadingStateKey, isLoading: false }, { root: true })
  },
  fetchFaculty: async ({ commit }, id) => {
    commit('setLoadingState', { key: loadingStateKey, isLoading: true }, { root: true })
    const result = await apolloClient.query({
      query: fetchFacultyQuery,
      variables: { id },
      fetchPolicy: 'no-cache'
    })
    commit('setFaculty', result.data.faculty)
    commit('setLoadingState', { key: loadingStateKey, isLoading: false }, { root: true })
  },
  createFaculty: async ({ commit }, payload) => {
    const result = await apolloClient.mutate({
      mutation: facultyCreateMutation,
      variables: { input: payload },
      fetchPolicy: 'no-cache'
    })

    commit('setFaculty', result.data.facultyCreate)
  },
  editFaculty: async ({ commit }, { id, patch }) => {
    const result = await apolloClient.mutate({
      mutation: facultyPatchMutation,
      variables: { id, patch },
      fetchPolicy: 'no-cache'
    })

    commit('setFaculty', result.data.facultyPatch)
  },
  deleteFaculty: async ({ commit }, id) => {
    await apolloClient.mutate({
      mutation: facultyDeleteMutation,
      variables: { id },
      fetchPolicy: 'no-cache'
    })

    commit('unsetFaculty', id)
  },

  setStaff: async ({ commit }, { id, username }) => {
    const result = await apolloClient.mutate({
      mutation: facultySetStaffMutation,
      variables: { id, username },
      fetchPolicy: 'no-cache'
    })

    commit('setFaculty', result.data.facultySetStaff)
  },
  setDean: async ({ commit }, { id, username }) => {
    const result = await apolloClient.mutate({
      mutation: facultySetDeanMutation,
      variables: { id, username },
      fetchPolicy: 'no-cache'
    })

    commit('setFaculty', result.data.facultySetDean)
  }
}

const mutations = {
  setAllFacultyList (state, payload) { state.all = payload },
  setFaculty: (state, faculty) => {
    let index = state.all.findIndex(project => project.id === faculty.id)
    if (index === -1) { index = state.all.length }
    Vue.set(state.all, index, faculty)
  },
  unsetFaculty: (state, id) => {
    const index = state.all.findIndex(faculty => faculty.id === id)
    if (index === -1) { return }
    Vue.delete(state.all, index)
  }
}

const getters = {
  getFacultyById: state => projectId => state.all.find(project => project.id === projectId)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
